import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConfigService } from '../../../../Services/app-config.service';
import { NotificationService } from '../../../../Services/notification.service';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-payment-type-list',
  templateUrl: './payment-type-list.component.html',
  styleUrls: ['./payment-type-list.component.css'],
  standalone: false
})
export class PaymentTypeListComponent extends ListPageBase implements OnInit {
  constructor(
    private aTable: DataService,
    private aToastr: NotificationService,
    private aRoute: Router,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  paymentTypeCount = 0;
  isLoading = false;



  vm: any = [];

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle($localize`:Payment Type List@@paymentTypeList:Payment Type List`);
    this.vm.list = [];
    this.getData();
  }

  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('payment_type', paramString).subscribe(
      (result: ResponseModel) => {
        // console.log(result);
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.paymentTypeCount = result.totalRecords;
        this.isLoading = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error(
          $localize`:Error loading Payment Type Data @@errorloadingPaymentTypeData:Error loading Payment Type Data`
        );
        console.log(error);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.aRoute.navigate(['admin/payment-type-form', { id: aID }]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('payment_type', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.paymentTypeCount = result.totalRecords;
        this.isLoading = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error(
          $localize`:Error loading Payment Type Data @@errorloadingPaymentTypeData:Error loading Payment Type Data`
        );
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
